import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.name);
    setIsOpen(false);
    window.open(cat.url, '_blank', 'noopener,nofollow');
  };

  return (
    <div ref={dropdownRef} className="relative w-full max-w-[320px] mx-auto z-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full h-12 px-5 flex items-center justify-between bg-white/90 backdrop-blur-sm border border-foreground-200/60 rounded-xl text-foreground-700 text-sm font-medium cursor-pointer transition-all duration-200 hover:border-accent-300 hover:bg-white"
      >
        <span className={selected ? 'text-foreground-900' : 'text-foreground-400'}>
          {selected || 'Выберите категорию'}
        </span>
        <i className={`${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-lg text-foreground-400 transition-transform duration-200`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 w-full bg-white border border-foreground-200/60 rounded-xl overflow-hidden max-h-[380px] overflow-y-auto">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleSelect(cat)}
              className="w-full px-5 py-3 flex items-center gap-3 text-left text-sm text-foreground-700 hover:bg-accent-50 transition-colors duration-150 cursor-pointer whitespace-nowrap border-b border-foreground-100/60 last:border-b-0"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50">
                <i className={`${cat.icon} text-accent-600 text-base`}></i>
              </span>
              {cat.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}